<div class="modal-content">
  <div class="modal-header">
    <h4 class="modal-title" id="myExtraLargeModalLabel">
      <ng-container>
        Preview terminal
      </ng-container>
    </h4>
    <button type="button" class="close" (click)="close()">×</button>
  </div>
  <div class="modal-body">

    <form [formGroup]="TerminalFormGroup" role="form" autocomplete="off">

      <div class="row form-horizontal">
        <div class="col-md-6 form-horizontal px-3">

          <div class="form-group">
            <br />
            <b style="color: orange;"> Terminal details</b>
            <div class="fc-divider dropdown-divider" style="border:1px solid teal"></div>
            <br />
          </div>

          <div class="form-group row">
            <label for="merchantNumber" class="col-4 col-form-label">Merchant Number</label>
            <div class="col-8">
              <input formControlName="merchantNumber" disabled class="form-control" id="merchantNumber" placeholder="Merchant Number" maxlength="4">
              <ul *ngIf="submitted" class="parsley-errors-list filled">
                <li *ngIf="TerminalFormGroup.controls['merchantNumber'].hasError('required')" class="parsley-required">Merchant number is required.</li>
              </ul>
            </div>
          </div>

          <div class="form-group row">
            <label for="terminalId" class="col-4 col-form-label">Terminal Id</label>
            <div class="col-8">
              <input formControlName="terminalId" class="form-control" id="terminalId" placeholder="Terminal Id" maxlength="8">
              <ul *ngIf="submitted" class="parsley-errors-list filled">
                <li *ngIf="TerminalFormGroup.controls['terminalId'].hasError('required')" class="parsley-required">Terminal Id is required.</li>
                <li *ngIf="TerminalFormGroup.controls['terminalId'].hasError('minlength')" class="parsley-error">Terminal Id must be atleast 8 characters.</li>
              </ul>
            </div>
          </div>


          <div class="form-group row">
            <label for="terminalId" class="col-4 col-form-label">Make</label>
            <div class="col-8">
              <input formControlName="terminalMake" class="form-control" id="terminalMake" placeholder="Make">
            </div>
          </div>

          <div class="form-group row">
            <label for="terminalId" class="col-4 col-form-label">Model</label>
            <div class="col-8">
              <input formControlName="terminalModel" class="form-control" id="terminalModel" placeholder="Model">
            </div>
          </div>

          <div class="form-group row">
            <label class="col-4 col-form-label">Retail</label>
            <div class="col-8">
              <textarea rows="4"
                        cols="24"
                        formControlName="retailFC"
                        class="form-control"
                        id="retailFC"
                        placeholder="Retail"></textarea>
            </div>
          </div>

          <div class="form-group row">
            <label class="col-4 col-form-label">Admin</label>
            <div class="col-8">
              <textarea rows="4"
                        cols="24"
                        formControlName="adminFC"
                        class="form-control"
                        id="adminFC"
                        placeholder="Admin"></textarea>
            </div>
          </div>

          <div class="form-group row">
            <label class="col-4 col-form-label">Banking window</label>
            <div class="col-8">
              <ng-select2 id="ctrlBankingWindow" formControlName="bankingWindowTimeFC" [data]="terminalInteractionBankingWindowTimes" [options]="select2options"></ng-select2>
              <ul *ngIf="submitted" class="parsley-errors-list filled">
                <li *ngIf="TerminalFormGroup.controls['bankingWindowTimeFC'].hasError('required')" class="parsley-required">Banking window is required.</li>
              </ul>
            </div>
          </div>

          <div class="form-group row">
            <label class="col-4 col-form-label">Parameter download day</label>
            <div class="col-8">
              <ng-select2 id="parameterDownloadDayFC" formControlName="parameterDownloadDayFC" [data]="parameterDownloadInteractionDays" [options]="select2options"></ng-select2>
              <ul *ngIf="submitted" class="parsley-errors-list filled">
                <li *ngIf="TerminalFormGroup.controls['parameterDownloadDayFC'].hasError('required')" class="parsley-required">Parameter download day is required.</li>
              </ul>
            </div>
          </div>

          <div class="form-group row">
            <label class="col-4 col-form-label">Parameter download window</label>
            <div class="col-8">
              <ng-select2 id="parameterDownloadWindowTimeFC" formControlName="parameterDownloadWindowTimeFC" [data]="terminalInteractionParameterTimes" [options]="select2options"></ng-select2>
              <ul *ngIf="submitted" class="parsley-errors-list filled">
                <li *ngIf="TerminalFormGroup.controls['parameterDownloadWindowTimeFC'].hasError('required')" class="parsley-required">Parameter download window is required.</li>
              </ul>
            </div>
          </div>

          <div class="form-group row">
            <label class="col-4 col-form-label">Delivery method</label>
            <div class="col-8">
              <label class="col-form-label">{{deliveryMethod}}</label>
            </div>
          </div>

          <div class="form-group row" *ngIf="client">
            <label for="NoteFC" class="col-4 col-form-label">Notes</label>
            <div class="col-8">
              <textarea rows="4" cols="24" formControlName="notesFC" class="form-control" id="notesFC" placeholder="Notes"></textarea>
              <br />
              <button type="button" style="width:100%"
                      class="btn btn-info waves-effect waves-light fa-pull-right"
                      (click)="SaveNote()">
                Save note
              </button>
            </div>
          </div>
          <div class="form-group row">
            <label for="viewNotes" class="col-4 col-form-label"></label>
            <div class="col-8">
              <button type="button" style="width:100%"
                      class="btn btn-info waves-effect waves-light fa-pull-right"
                      (click)="viewNotes()">
                View notes
              </button>
            </div>
          </div>

        </div>
        <div class="col-md-6 form-horizontal px-3">


          <div class="form-group">
            <br />
            <b style="color: orange;"> Terminal delivery address information</b>
            <div class="fc-divider dropdown-divider" style="border:1px solid teal"></div>
            <br />
          </div>

          <div class="form-group row">
            <label class="col-4 col-form-label">Contact's name & surname</label>
            <div class="col-8">
              <input formControlName="ContactNameSurnameFC" class="form-control" id="ContactNameSurnameFC" placeholder="Contact name and surname" />
              <ul *ngIf="submitted" class="parsley-errors-list filled">
                <li *ngIf="TerminalFormGroup.controls['ContactNameSurnameFC'].hasError('required')" class="parsley-required">Contact's name and surname is required.</li>
              </ul>
            </div>
          </div>

          <div class="form-group row">
            <label class="col-4 col-form-label">Contact's cell number</label>
            <div class="col-8">
              <input formControlName="ContactNameCellNrFC" class="form-control" id="ContactNameCellNrFC" placeholder="Contact cell number" />
              <ul *ngIf="submitted" class="parsley-errors-list filled">
                <li *ngIf="TerminalFormGroup.controls['ContactNameCellNrFC'].hasError('required')" class="parsley-required">Contact's cell is required.</li>
              </ul>
            </div>
          </div>

          <div class="form-group row">
            <label class="col-4 col-form-label">Contact's email address</label>
            <div class="col-8">
              <textarea rows="2" formControlName="ContactEmailAddressFC" class="form-control" id="ContactEmailAddressFC" placeholder="Contact email address"></textarea>
              <ul *ngIf="submitted" class="parsley-errors-list filled">
                <li *ngIf="TerminalFormGroup.controls['ContactEmailAddressFC'].hasError('required')" class="parsley-required">Contact's email address is required.</li>
              </ul>
            </div>
          </div>

          <div class="form-group row">
            <label class="col-4 col-form-label">Contact's Address</label>
            <div class="col-8">
              <textarea rows="4" cols="24" formControlName="ContactAddressFC" class="form-control" id="ContactAddressFC" placeholder="Address"></textarea>
              <ul *ngIf="submitted" class="parsley-errors-list filled">
                <li *ngIf="TerminalFormGroup.controls['ContactAddressFC'].hasError('required')" class="parsley-required">Contact's address is required.</li>
              </ul>
            </div>
          </div>

          <div class="form-group row">
            <label for="errors" class="col-4 col-form-label">Serial number<i class="asterisk-acs" ngbTooltip="Serial number is required"> *</i></label>
            <div class="col-8">
              <input formControlName="SerialNumberFC" class="form-control" id="SerialNumberFC" placeholder="Serial number" />
              <ul *ngIf="submitted" class="parsley-errors-list filled">
                <li *ngIf="TerminalFormGroup.controls['SerialNumberFC'].hasError('required')" class="parsley-required">Serial number is required.</li>
              </ul>
            </div>
          </div>

          <div class="form-group row">
            <label for="SimNumberFC" class="col-4 col-form-label">Base serial number</label>
            <div class="col-8">
              <input formControlName="BaseSerialNumberFC" class="form-control" id="BaseSerialNumberFC" placeholder="Base/Craddle serial number" />
            </div>
          </div>

          <div class="form-group row">
            <label for="SimNumberFC" class="col-4 col-form-label">Sim number<i class="asterisk-acs" ngbTooltip="Sim number is required"> *</i></label>
            <div class="col-8">
              <input formControlName="SimNumberFC" class="form-control" id="SimNumberFC" placeholder="Sim number" />
              <ul *ngIf="submitted" class="parsley-errors-list filled">
                <li *ngIf="TerminalFormGroup.controls['SimNumberFC'].hasError('required')" class="parsley-required">Sim number is required.</li>
              </ul>
            </div>
          </div>



          



        </div>
        <div class="col-md-12 form-horizontal" *ngIf="isCourier">
          <!--<div class="col-12">-->
          <input formControlName="dispatch" style="display: inline; width: 40px; color: red;" type="checkbox" id="dispatch" placeholder="Dispatch" /> <b style="color: red">By selecting this checkbox, you acknowledge that Aramex will be notified about the terminal(s).</b>
          <!--</div>-->

        </div>

        <div class="col-12 form-horizontal px-3">
          <div class="col-6"></div>

          <div class="form-group row" *ngIf="isOwner">
            <div class="col-12">
              <button type="button"
                      class="btn btn-info waves-effect waves-light fa-pull-right"
                      (click)="save()">
                Save & Close
              </button>
            </div>
          </div>

          </div>

        </div>

</form>
  </div>
</div>



<!--<div class="form-group row" *ngIf="confirm">
  <div class="col-12">
    <br />
    <input formControlName="dispatch" style="display:inline;width: 10%; color:red" type="checkbox" id="dispatch" placeholder="Dispatch" /> <b style="color: red">By selecting this checkbox, you acknowledge that Aramex will be notified about the terminal(s).</b>
  </div>
</div>
<div class="form-group row">
  <div class="col-12">
    <button type="button" *ngIf="buttonSave"
            class="btn btn-info waves-effect waves-light fa-pull-right"
            (click)="save()">
      Save & Close
    </button>
  </div>
</div>-->
